import React from 'react'

import { DataItem, LinkTag } from 'scrivito'

/**
 * Wrapper around Scrivito's `LinkTag` that opens a `DataItem`
 * in a new browser tab.
 *
 * Use this to wrap tiles, titles, or menu entries when you want
 * the whole element to behave as an "open in new tab" link.
 */
interface DataItemNewTabLinkProps extends React.ComponentProps<typeof LinkTag> {
  dataItem: DataItem
}

export const DataItemNewTabLink: React.FC<DataItemNewTabLinkProps> = ({
  dataItem,
  children,
  className,
  ...rest
}) => {
  return (
    <LinkTag
      to={dataItem}
      target="_blank"
      rel="noreferrer"
      className={className}
      {...rest}
    >
      {children}
    </LinkTag>
  )
}
